import { saveAs } from 'file-saver'
import { postPackageExportRegistration } from '../services/crash-package-exports'
import { createCrashPackageZip } from './create-crash-package-zip'
import { markIncidentExported } from './incident-store'

/**
 * Scarica il ZIP, marca le righe come exported e registra il pacchetto se online.
 *
 * @param {Object} params
 * @param {Array<{ clientUuid: string, payload: object }>} params.rows
 * @param {Record<string, unknown> | null} params.formModel
 * @param {string | number} params.createdByUserId
 * @param {string | null | undefined} params.bearer
 * @returns {Promise<{ packageId: string, manifest: object }>}
 */
export async function downloadCrashPackageZip({
  rows,
  formModel,
  createdByUserId,
  bearer,
}) {
  const { blob, manifest, packageId, clientUuids } = await createCrashPackageZip({
    rows,
    formModel,
    createdByUserId,
  })

  saveAs(blob, `crash-package-${packageId}.zip`)

  for (const clientUuid of clientUuids) {
    await markIncidentExported(clientUuid)
  }

  registerPackageIfOnline(manifest, bearer)
  return { packageId, manifest }
}

/**
 * @param {object} manifest
 * @param {string | null | undefined} bearer
 */
function registerPackageIfOnline(manifest, bearer) {
  const hasBearer = Boolean(bearer) && bearer !== '__offline__'
  const isBrowserOnline =
    typeof navigator !== 'undefined' && navigator.onLine === true
  if (!hasBearer || !isBrowserOnline) {
    return
  }
  postPackageExportRegistration(manifest, bearer).catch(() => {})
}
